import { Icon, type IconProps } from '@chakra-ui/react';
import {
	ArrowUpIcon,
	ChatAlt2Icon,
	CheckIcon,
	ChevronUpIcon,
	DocumentDownloadIcon,
	DocumentTextIcon,
	DotsHorizontalIcon,
	DuplicateIcon,
	PhotographIcon,
	PlusIcon,
	SparklesIcon,
	TrashIcon,
	XIcon,
} from '@heroicons/react/outline';

/**
 * Bizy-kit icon set. Wraps Heroicons (v1 outline) in a Chakra `Icon` so
 * the ported node/card components keep using Chakra style props
 * (`boxSize`, `color`, …) exactly as they did against the design-system
 * icon set. Kept dependency-light: Heroicons is a peer dependency that
 * both Kaleidoscope and Bizy Desktop already ship.
 */
function wrap(glyph: typeof CheckIcon) {
	return function BizyKitIcon(props: IconProps) {
		return <Icon as={glyph} {...props} />;
	};
}

export const ArrowUpOutline = wrap(ArrowUpIcon);
export const ChatAlt2Outline = wrap(ChatAlt2Icon);
export const CheckOutline = wrap(CheckIcon);
export const ChevronUpOutline = wrap(ChevronUpIcon);
export const DocumentDownloadOutline = wrap(DocumentDownloadIcon);
export const DocumentTextOutline = wrap(DocumentTextIcon);
export const DotsHorizontalOutline = wrap(DotsHorizontalIcon);
export const DuplicateOutline = wrap(DuplicateIcon);
export const PhotographOutline = wrap(PhotographIcon);
export const PlusOutline = wrap(PlusIcon);
export const SparklesOutline = wrap(SparklesIcon);
export const TrashOutline = wrap(TrashIcon);
export const XOutline = wrap(XIcon);
